import {useEffect} from 'react'
import { Grid } from "@mui/material"
import Header from '../login-register/components/header';

const CareersPage = () => {

    useEffect(() => {
        document.title = "Careers";
      }, []);

    return (
        <>
            <Header showIntro={true} showLogin={true} />
            <Grid component="main" container display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ height: `calc(100vh - 64px)` }}>
                <h1>This Page is Under Construction</h1>
            </Grid>
        </>
    )
}

export default CareersPage;
